export default __webpack_public_path__ + "img/eZzxUEsD.88e538db.svg";